<template >    
<!-- Si la sesión del usuario es activa(true) entonces visualizar el Dashboard -->
<div v-if="LoginOnline === true">
	<div :class="containerClass" @click="onWrapperClick">
		<AppTopBar @menu-toggle="onMenuToggle" />

        <transition name="layout-sidebar">
            <div v-if="modeAdmin === false" :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link to="/">                        
                    </router-link>
                </div>

                <AppProfile />
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </div>
            <div v-else :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link to="/">                        
                    </router-link>
                </div>

                <AppProfile />
                <AppMenu :model="menuAdmin" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>

		<div class="layout-main">
			<router-view />
		</div>
		

		<AppFooter />
	</div>
</div>
<!-- Si la sesión del usuario no se encuentra activa, entonces mostrar la vista LoginForm -->
<div v-else>
    <div class="p-d-flex p-jc-center">	
		<div class="p-col-12">
        <div class="layout-footer" style="text-align: center;background-color: rgb(24, 56, 107);color:white;font-size:14px;">
                <span class="footer-text" style="margin-right: 5px;"><b>&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp; SIACV v1.0 </b> &nbsp;&nbsp;-&nbsp;  <b>SISTEMA ADMINISTRADOR DE CURRICULUM VITAE DOCENTES (FORMATO CONAIC) &nbsp;&nbsp;&nbsp;&nbsp;||</b></span>				
        </div>
		<br><br><br><br><br>
		<div class="card" style="height: 390px; width:70%; margin: auto;">

			<Splitter style="height: 360px; width:100%">
				<SplitterPanel class="p-d-flex p-ai-center p-jc-center" style="background-color: #8dcdff;">                     
						<img alt="logo" src="assets/layout/images/logo_WebApp.png" aria-haspopup="true">                    
				</SplitterPanel>
				<SplitterPanel class="p-d-flex p-ai-center p-jc-center" style="background-color: #0c376c; border: 1px solid #e1e4e8;">						
				<Panel header="Ingreso al SIACV v1.0" style="width: 95%;">		
					<br>		                    
                        <div class="p-field">
                            <div class="p-float-label p-input-icon-right">
								<i class="pi pi-user" />
                                <InputText id="nameu" autofocus v-model="userItem.nomusuario" :class="{'p-invalid': submitted && validarErrores.nomusuario}" style="width: 300px;" placeholder="Correo Institucional"/>
                                <small class="p-error" v-show="submitted && validarErrores.nomusuario"><br>Debes ingresar el nombre de usuario</small>
                            </div>                            
                        </div>
						
						<div class="p-field" >
                            <div class="p-float-label" style="width: 300px;">								
                                <Password id="passu" v-model="userItem.passuser" :class="{'p-invalid': submitted && validarErrores.passuser}" toggleMask placeholder="Contraseña">
								<template #header>
                                        <h6>Ingresa la contraseña</h6>
                                    </template>
                                    <template #footer="sp">
                                        {{sp.level}}
                                        <Divider />
                                        <p class="p-mt-2">Sugerencias:</p>
                                        <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                                            <li>Al menos una letra minuscula</li>
                                            <li>Al menos una letra mayuscula</li>
                                            <li>Al menos un número</li>
                                            <li>Minimo 8 caracteres</li>
                                        </ul>
                                    </template>
                                </Password>
                                <small class="p-error" v-show="submitted && validarErrores.passuser"><br>Debes ingresar la contraseña</small>
                            </div>                            
                        </div>
						<div class="p-field-checkbox">							
                            <Checkbox id="accept" name="accept" value="Accept" v-model="userItem.aceptar" :class="{'p-invalid':validarErrores.aceptar && submitted}" />
                            <label for="accept">Estoy de acuerdo con los términos y condiciones*&nbsp; &nbsp;&nbsp; &nbsp;</label>							
                            <Button label="" icon="pi pi-external-link" @click="openBasicTerm" />
                            <small class="p-error" v-show="submitted && validarErrores.aceptar">Debes aceptar las condiciones</small>
                        </div><br>
                        <Button label="Ingresar al Sistema" class="p-mt-2" @click="validarUsuario"/> 

				</Panel>
				</SplitterPanel>				
				</Splitter>
                <Toast/>

				<Dialog header="Términos y condiciones" v-model:visible="displayBasicTerm" :style="{width: '50vw'}">
					<b>1. Condiciones básicas.</b><br><br>
                    <p align="justify">El usuario es responsable del uso que haga y del contenido que registre dentro de la aplicación web. Proporcione sólo contenido solicitado de acuerdo al formato de Curriculum Vitae establecido por la Dirección y Secretaría Académica de la Facultad de Negocios CIV de la UNACH, con base a los formatos oficiales que establecen los organismos acreditadores.<br><br>
La información proporcionada es confidencial y será utilizada exclusivamente para efectos de los procesos de acreditación. Es importante proporcionar datos verídicos de acuerdo a la productividad académica del docente, mismos que permitirán la generación del documento CVU del docente. No es necesario incluir anexos ni comprobantes originales.<br><br>
El usuario deberá respetar en todo momento los presentes Términos y Condiciones de Uso de la aplicación web. De forma expresa el usuario manifiesta que utilizará el software de forma diligente y asumiendo cualquier responsabilidad que pudiera derivarse del incumplimiento de las normas.</p>                    
                </Dialog>
			</div>	
            <br><br><br><br><br><br><br><br>
            <div class="layout-footer" style="text-align: center;background-color: rgb(24, 56, 107);color:white;font-size:14px;">
                <span class="footer-text" style="margin-right: 5px;"><b>&nbsp;&nbsp;Derechos reservados &copy;2021 &nbsp;|&nbsp; Facultad de Negocios Campus IV </b> &nbsp;&nbsp;|&nbsp;&nbsp;  <b> Universidad Autónoma de Chiapas </b></span>				
            </div>
		</div>
	</div>
</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppProfile from './AppProfile.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';
import axios from 'axios';
import apiAuthUser from '@/service/AuthUserService';

export default {
    data() {
        return {
            LoginOnline: false,
            modeAdmin:false,
            valSession:null,
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            userItem: {
				nomusuario: '',
				passuser: '',
				aceptar:null						
			},
            validarErrores: {},
            respuesta:{},
			submitted: false,
            displayBasicTerm: false,					
            menu : [
                {label: 'Dashboard SIACV', icon: 'pi pi-fw pi-home', to: '/'},
				{label: 'Curriculum CONAIC', icon: 'pi pi-fw pi-id-card',
					items: [
						{label: 'Datos Personales', icon: 'pi pi-fw pi-id-card', to: '/formDatosP'},
						{label: 'Grados Académicos', icon: 'pi pi-fw pi-bookmark', to: '/formGradosAcad'},
                        {label: 'Experiencia Académica', icon: 'pi pi-fw pi-briefcase', to: '/formExperAcad'},
                        {label: 'Actividad Docente', icon: 'pi pi-fw pi-users', to: '/formActDocente'},
						{label: 'Experiencia Profesional', icon: 'pi pi-fw pi-credit-card', to: '/formExperProf'},
						{label: 'Productos Académicos', icon: 'pi pi-fw pi-copy', to: '/formProductosA'},
						{label: 'Asociaciones profesionales', icon: 'pi pi-fw pi-list', to: '/formAsoc'},
						{label: 'Premios y Distinciones', icon: 'pi pi-fw pi-shield', to: '/formPremios'},
						{label: 'Logros Académicos', icon: 'pi pi-fw pi-tags', to: '/formLogros'},
						{label: 'Libros publicados', icon: 'pi pi-fw pi-book', to: '/formLibrosPublicados'},
						{label: 'Material Didáctico', icon: 'pi pi-fw pi-file', to: '/formMaterialDidac'},
					]
				},
				{
					label: "Reportes", icon:'pi pi-fw pi-globe',
					items: [
						{label: 'CV Docente (pdf)', icon:'pi pi-fw pi-file-pdf', to:'/formCVDocente'},					
					]
				},                
				{
					label: "Créditos", icon:'pi pi-fw pi-bookmark',
					items: [
						{label: 'Descripción Proyecto', icon:'pi pi-fw pi-desktop', to:'/formCreditos'},					
					]
				},
                {label: 'Salir', icon: 'pi pi-fw pi-power-off', command: () => {
                    window.localStorage.removeItem('noPlaza');
                    window.localStorage.removeItem('tokenUser');
                    window.localStorage.removeItem('nombreDocenteUser');
                    this.userItem.nomusuario = "";
                    this.userItem.passuser = "";
                    this.LoginOnline = false;
                    this.$router.push('/');
                } }                
            ],
            menuAdmin : [                
				{label: 'Administración de SIACV', icon: 'pi pi-fw pi-id-card',
					items: [
						{label: 'Control de usuarios', icon: 'pi pi-fw pi-user-edit', to: '/formUsuariosAdmin'},
						{label: 'Listado de Docentes CVU', icon: 'pi pi-fw pi-users', to: '/formDocentesAdmin'}
					]
				},                
				{
					label: "Créditos", icon:'pi pi-fw pi-bookmark',
					items: [
						{label: 'Descripción Proyecto', icon:'pi pi-fw pi-desktop', to:'/formCreditos'},					
					]
				},
                {label: 'Salir', icon: 'pi pi-fw pi-power-off', command: () => {
                    window.localStorage.removeItem('noPlaza');
                    window.localStorage.removeItem('tokenUser');
                    window.localStorage.removeItem('nombreDocenteUser');
                    this.userItem.nomusuario = "";
                    this.userItem.passuser = "";
                    this.LoginOnline = false;
                    this.$router.push('/');
                } }                
            ]
        }
    },
    mounted() {
        if(window.localStorage.getItem('noPlaza')!==null)  //validar sesión activa del Usuario
            this.LoginOnline = true;
	},
    watch: {
        $route() {
            this.menuActive = false;
            this.submitted = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {        
        openBasicTerm() {
				this.displayBasicTerm = true;				
		},
        cerrarSesion(){

        },
		validarUsuario() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.validarAuthUser();					
				}
		},
		validarAuthUser: async function() {
            const requestData = {					
					username: this.userItem.nomusuario,
                    password: this.userItem.passuser
            }
			const data = await apiAuthUser.autentificaUser(requestData);
            this.respuesta = data;

            if(this.respuesta.status === false)
                this.$toast.add({severity:'error', summary: 'Validación de Acceso', detail: 'Nombre de usuario y/o Contraseña incorrectos', life: 3000});
            else{				
                window.localStorage.setItem('noPlaza', this.respuesta.data.noPlaza);
                window.sessionStorage.setItem('noPlaza', this.respuesta.data.noPlaza);
                window.localStorage.setItem('nombreDocenteUser',this.respuesta.data.full_name);
                window.localStorage.setItem('tokenUser', this.respuesta.data.token);
                axios.defaults.headers.common['token'] = this.respuesta.data.token;

                this.LoginOnline = true;  //La autentificación es correcta, pasa al Dashboard
                if(this.respuesta.data.noPlaza === '1'){
                    this.modeAdmin = true; //Se carga la interfaz en modo Administrador
                }
            }
		},
		validarForm() {
				if (!this.userItem.nomusuario.trim())
					this.validarErrores['nomusuario'] = true;
				else
					delete this.validarErrores['nomusuario'];

				if (!this.userItem.passuser.trim())
					this.validarErrores['passuser'] = true;
				else
					delete this.validarErrores['passuser'];		
                
                if (!this.userItem.aceptar === true)
					this.validarErrores['aceptar'] = true;
				else
					delete this.validarErrores['aceptar'];	

				return !Object.keys(this.validarErrores).length;
		},
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
		onLayoutColorChange(layoutColorMode) {
			this.layoutColorMode = layoutColorMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth > 1024;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
                else
                    return true;
            }
            else {
                return true;
            }
        },
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$appState.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        sidebarClass() {
            return ['layout-sidebar', {
                'layout-sidebar-dark': this.layoutColorMode === 'dark',
                'layout-sidebar-light': this.layoutColorMode === 'light'
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppProfile': AppProfile,
        'AppMenu': AppMenu,        
        'AppFooter': AppFooter,
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
